// extracted by css-extract-rspack-plugin
export default {"root":"OVIo6y"};